module.exports = "    <div class=\"wrapper\">\n        <navigation></navigation>\n        <div class=\"main-panel\">\n            <header-component></header-component>\n            <div class=\"content margin-top-65\">\n                <div class=\"container-fluid\">\n                  <main>\n                      <ui-view></ui-view>\n                  </main>\n                </div>\n                <!--<footer-component></footer-component>-->\n            </div>\n        </div>\n    </div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/main.html
// module id = 1338
// module chunks = 0